'use strict';

// Real, scannable QR codes (replaces the old decorative placeholder). Thin wrapper over qrcode-svg,
// used in the browser (bundled by esbuild) and reusable server-side. Renders an SVG string.
const QRCode = require('qrcode-svg');

function qrSvg(content, size) {
  const px = size || 168;
  const s = String(content == null ? '' : content);
  if (!s) return '';
  try {
    return new QRCode({ content: s, padding: 1, width: px, height: px, ecl: 'M', color: '#1A1D29', background: '#ffffff' }).svg();
  } catch (_) { return ''; }
}

module.exports = { qrSvg };
